import React from 'react'

export default function OurStory() {
  return (
    <div>
        <div className='our-story'>
            <div className='duke-story'>
                There was once a small farm in Ireland, not far from Dingle. In that farm, there was a cabbage patch. In that cabbage patch, there was a bodhran, with a small baby inside.
                This baby has nothing to do with Duke. He's not even from Ireland.
            </div>
            <div className='mo-story'>
                Scene: A gentleman of great renown sits in his leather chair, gently rocking back and forth. He closes his eyes as he listens to his music as Joan Baez begins to play. He opens his eyes, turns to you, and says, "It all started in Del Rio. Frankly, I dont remember it, but Del Rio stinks!" And that man was Sanity Clause. And this is Mo's story.
            </div>

        </div>
        <br/>
        <div className='together-story'>
            ... and the rest is history.
        </div>
    </div>

  )
}
